import script from "./DomainModelReadModel.vue?vue&type=script&setup=true&lang=js"
export * from "./DomainModelReadModel.vue?vue&type=script&setup=true&lang=js"

import "./DomainModelReadModel.vue?vue&type=style&index=0&id=b6a7cbd6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b6a7cbd6"]])

export default __exports__